export default __webpack_public_path__ + "static/media/image2.f556580f.jpeg";